import { readApiErrorEnvelope } from '#/utils/requestError';

/**
 * 五類單據（客訂／銷貨／物料採購／雜項採購／進貨）的幣別錯誤 → 表單 `currencyId` 欄位錯誤。
 * 後端以 `field=currency_id` 標示；錯誤碼為 `{DOC}_CURRENCY_REQUIRED／NOT_FOUND／EXCHANGE_RATE_INVALID`。
 * `STOCK_RECEIPT_TWD_CURRENCY_UNAVAILABLE`（工單來源進貨）沒有可編輯欄位，不在此處理。
 */
const CURRENCY_ERROR_MESSAGES = [
  ['_CURRENCY_EXCHANGE_RATE_INVALID', '此幣別沒有有效的預設匯率，請改選其他幣別或請管理員設定匯率'],
  ['_CURRENCY_NOT_FOUND', '幣別不存在或已停用，請重新選擇'],
  ['_CURRENCY_REQUIRED', '請選擇幣別'],
];

const CURRENCY_FIELD_KEYS = new Set(['currency_id', 'currencyId']);

/**
 * @param {unknown} error
 * @returns {string|null} 欄位錯誤文案；不是幣別欄位錯誤時回 null。
 */
export function getDocumentCurrencyFieldErrorMessage(error) {
  const envelope = readApiErrorEnvelope(error);
  if (!envelope) {
    return null;
  }

  const matched = CURRENCY_ERROR_MESSAGES.find(([suffix]) => envelope.code.endsWith(suffix));
  if (matched) {
    return matched[1];
  }

  if (envelope.field && CURRENCY_FIELD_KEYS.has(envelope.field)) {
    return envelope.message || '幣別有誤，請重新選擇';
  }

  return null;
}

/**
 * 幣別錯誤時在 RHF `currencyId` 標示錯誤，保留使用者選擇；不改送 currency_code 重試。
 *
 * @param {unknown} error
 * @param {Function} setError RHF `setError`
 * @returns {boolean} 是否已標示
 */
export function applyDocumentCurrencyFieldError(error, setError) {
  const message = getDocumentCurrencyFieldErrorMessage(error);
  if (!message || typeof setError !== 'function') {
    return false;
  }
  setError('currencyId', { type: 'server', message }, { shouldFocus: true });
  return true;
}
